import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {RestHttpService} from "@catcore/services/rest-http.service";
import {Restangular} from "ngx-restangular";
import {extractDataFromProperty} from "@catcore/utils";
import {Resource} from "@catfeatures/types";
import {ProjectEvidFunction} from "@catmodels/project-evid-functions/types";

const singleton = () => {
  return (target) => {
    target.currentSource = new BehaviorSubject(null);
    target.current = null;
    target.current$ = target.currentSource.asObservable();

    target.loadAsCurrent = (id: string) => {
      this.getOne(id).subscribe((feature: any) => {
        this.currentSource.next(feature);
      });
    };

    target.refreshCurrent = () => {
      if (this.current) {
        this.loadAsCurrent(this.current.id);
      }
    };
  };
};

@Injectable()
@singleton()
export class ProjectEvidFunctionService extends RestHttpService<any> {

  constructor(service: Restangular) {
    super('project-evid-functions', service);
  }

  extractLinkedPortsFor(resourceModel: ProjectEvidFunction): any[] {
    const lookupKey = 'linked_ports';
    return extractDataFromProperty(resourceModel as Resource, lookupKey);
  }

  extractLinkedUnitsFor(resourceModel: ProjectEvidFunction): any[] {
    const lookupKey = 'linked_units';
    return extractDataFromProperty(resourceModel as Resource, lookupKey);
  }

  extractLinkedServicesFor(resourceModel: ProjectEvidFunction): any[] {
    const lookupKey = 'linked_services';
    return extractDataFromProperty(resourceModel as Resource, lookupKey);
  }

  extractLinkedVidsFor(resourceModel: ProjectEvidFunction): any[] {
    const lookupKey = 'linked_vids';
    return extractDataFromProperty(resourceModel as Resource, lookupKey);
  }

  extractLinkedGuiZonesFor(resourceModel: ProjectEvidFunction): any[] {
    const lookupKey = 'linked_gui_zones';
    return extractDataFromProperty(resourceModel as Resource, lookupKey);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/project-evid-functions/services/project-evid-function/project-evid-function.service.ts